import "./Header.scss";
import { useState, useEffect } from "react";
import ReplyOutlinedIcon from "@mui/icons-material/ReplyOutlined";
import SvgIcon from "@mui/material/SvgIcon";
import { useHistory } from "react-router-dom";
import ConfirmModal from "./ConfirmModal";
import CountdownModal from "./CountdownModal";
import axiosInstance from "../api/axiosInstance";
import { rootReducer } from "../store/store";
import { useSelector } from "react-redux";
import ReservationList from "../pages/reservationList";
import ReservationService from "../api/ReservationService";

interface ConfirmModalProps {
  onConfirm?: () => void;
}

type AuthState = ReturnType<typeof rootReducer>;

const Header: React.FC<ConfirmModalProps> = ({ onConfirm }) => {
  const [time, setTime] = useState<string>("");
  const [timer, setTimer] = useState<NodeJS.Timeout | null>(null);
  const [showModal, setShowModal] = useState(false);
  const history = useHistory();
  const resInfo = useSelector((state: AuthState) => state.store.resOneInfo);

  const getCurrentDateTimeString = () => {
    const days = ["일", "월", "화", "수", "목", "금", "토"];
    const now = new Date();

    const month = (now.getMonth() + 1).toString().padStart(2, "0"); // 두 자리로 만들기
    const day = now.getDate().toString().padStart(2, "0");
    const hours = now.getHours().toString().padStart(2, "0");
    const minutes = now.getMinutes().toString().padStart(2, "0");
    const dayOfWeek = days[now.getDay()];

    // 문자열로 조합
    const dateTimeString = `${month}/${day}(${dayOfWeek}) ${hours}:${minutes}`;

    return dateTimeString;
  };

  const Time = () => {
    setTime(getCurrentDateTimeString());
  };

  const startTimer = () => {
    // 기존 타이머가 있다면 clear
    if (timer) {
      clearTimeout(timer);
    }

    // 30초 타이머 시작
    const newTimer = setTimeout(() => {
      setShowModal(true);
      // 특정 페이지로 이동
    }, 6000);

    setTimer(newTimer);
  };

  const goBack = async () => {
    if (window.location.pathname === "/reservation") {
      ReservationService.processOpen(
        resInfo?.data?.companyId || "", 
        resInfo?.data?.reservationId || "", 
        resInfo?.data?.processLockVersion || 0
      ).then((res) => {
        console.log(res);
        if (res.data.status === 200) {
          history.goBack();
        }
      });
    } else {
      history.goBack();
    }
  };

  // 1분마다 함수를 실행합니다.
  useEffect(() => {
    startTimer();
    const interval = setInterval(Time, 0);
    window.addEventListener("timer", startTimer);
    return () => {
      if (timer) {
        clearTimeout(timer);
      }
      clearInterval(interval);
    };
  }, []);

  return (
    <>
      <div className="header-wrap">
        <div className="dec-wrap">
          {window.location.pathname !== "/finish" && (
            <div id="backButton" className="back-step">
              <SvgIcon
                component={ReplyOutlinedIcon}
                style={{ fontSize: "3em", color: "#CBD2DA" }}
                onClick={() => {
                  if (onConfirm) onConfirm();
                  else goBack();
                }}
              ></SvgIcon>
            </div>
          )}
          <span className="dec">렌터카 키오스크</span>
          <span className="time">{time}</span>
        </div>
      </div>

      {window.location.pathname !== "/main" && (
        <CountdownModal
          remainingTime={60}
          reservationId={resInfo?.data?.reservationId}
          companyId={resInfo?.data?.companyId}
          processLockVersion={resInfo?.data?.processLockVersion}
        />
      )}
    </>
  );
};

export default Header;
